import { render, staticRenderFns } from "./PidTypeDelete.vue?vue&type=template&id=231adc34&scoped=true"
import script from "./PidTypeDelete.vue?vue&type=script&lang=js"
export * from "./PidTypeDelete.vue?vue&type=script&lang=js"
import style0 from "./PidTypeDelete.vue?vue&type=style&index=0&id=231adc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231adc34",
  null
  
)

export default component.exports